//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        src: {
            type: String,
            required: true
        },
        poster: {
            type: String,
            default: ''
        },
        borderRadius: {
            type: [String, Number],
            default: 10
        },
        mode: {
            type: String,
            default: 'aspectFill' // aspectFill aspectFit widthFix heightFix
        },
        fullScreen: {
            type: Boolean,
            default: true
        },
        showControls: {
            type: Boolean,
            default: true
        },
        height: {
            type: [String, Number],
            default: 'auto'
        },
        width: {
            type: [String, Number],
            default: 'auto'
        }
    },
    data() {
        return {
            playing: false
        };
    },
    computed: {
        videoCls() {
            if (this.playing && this.fullScreen) {
                return 'heightFix';
            }
            return this.mode;
        },
        h() {
            if (isNaN(this.height)) {
                return this.height;
            } else {
                return this.height + 'px';
            }
        },
        w() {
            if (isNaN(this.width)) {
                return this.width;
            } else {
                return this.width + 'px';
            }
        }
    },
    watch: {
        src() {
            this.playing = false;
        }
    },
    methods: {
        play() {
            // this.$refs.video.play();
            // this.playing = true;
            this.$emit('play');
        },
        stop() {
            // this.$refs.video.pause();
            // this.playing = false;
            this.$emit('stop');
        },
        ended() {
            this.playing = false;
        }
    }
};
